/**
 * Contenido por defecto de Aviso de privacidad / Cookies (CMS site/legal).
 * El cliente puede editarlo desde /admin/privacidad.
 */

export const LEGAL_DOC_ID = "legal";

export const DEFAULT_CONSENT_MATRIX = [
  {
    id: "essential",
    label: "Cookies esenciales",
    withConsent:
      "Activas siempre. Guardan su elección de cookies y permiten seguridad básica del sitio y del panel.",
    withoutConsent:
      "Siguen activas (necesarias). No se puede rechazar esta categoría sin romper el sitio.",
  },
  {
    id: "functional",
    label: "Cookies funcionales",
    withConsent: "Se guarda el carrito de cotización y preferencias de ayuda del CMS.",
    withoutConsent: "El carrito puede no persistir entre visitas; el sitio sigue usable.",
  },
  {
    id: "analytics",
    label: "Analítica de visitas",
    withConsent:
      "Se registran visitas totales y visitas por dirección IP (dato identificable) para informes internos.",
    withoutConsent:
      "Solo estadísticas agregadas (totales del día y rutas más vistas), sin guardar IP ni otros datos sensibles.",
  },
  {
    id: "thirdParty",
    label: "Contenido de terceros",
    withConsent: "Se cargan YouTube, Facebook, Google Maps y Heyzine (pueden usar cookies ajenas).",
    withoutConsent:
      "Esos embeds no cargan; se muestra un aviso para activarlos o configurar cookies.",
  },
  {
    id: "forms",
    label: "Formularios (contacto, cotización, quejas)",
    withConsent:
      "Con la casilla del aviso aceptada se envían los datos del formulario a AGDYSA y encargados (Firestore, correo, hojas).",
    withoutConsent:
      "No se envía el formulario: la casilla es obligatoria. Sin aceptación no hay recolección por ese canal.",
  },
];

export const DEFAULT_PRIVACY_SECTIONS = [
  {
    id: "intro",
    title: "Responsable",
    body: "AGDYSA / LABSYSO es el responsable del tratamiento de los datos personales que usted proporciona a través de este sitio web, sus formularios y canales asociados, conforme a la Ley para la Protección de Datos Personales de El Salvador (D.L. 144).",
  },
  {
    id: "puntos",
    title: "Avisos en puntos de recolección",
    body: "Este aviso aplica a formularios del sitio (consulta, cotización, buzón LABSYSO), paneles asociados y, de forma complementaria, a otros puntos operativos (formularios físicos, contratos, campañas, videovigilancia) que tendrán sus propios avisos institucionales.",
  },
  {
    id: "formularios",
    title: "Formularios web: datos que recolectamos",
    body: "Contacto: nombre, apellido, teléfono, correo, motivo y mensaje. Cotización: empresa, contacto, rubro, servicios y preferencias. LABSYSO: identificación, contacto, relato y eventuales datos de terceros que usted mencione. Panel /admin: correo, credenciales y OTP de personal autorizado.",
  },
  {
    id: "finalidades",
    title: "Finalidades",
    body: "Atender consultas y cotizaciones; gestionar quejas/sugerencias LABSYSO; seguimiento comercial interno; operar el CMS; cumplir obligaciones legales.",
  },
  {
    id: "destinatarios",
    title: "Destinatarios y encargados",
    body: "Personal autorizado AGDYSA/LABSYSO; Firebase/Google (Auth, Firestore, Functions); Apps Script/Hojas cuando aplique; correo institucional. Puede implicar tratamiento fuera de El Salvador.",
  },
  {
    id: "bases",
    title: "Bases de tratamiento",
    body: "Consentimiento expreso en formularios y, cuando corresponda, medidas precontractuales o ejecución de la relación comercial.",
  },
  {
    id: "arco",
    title: "Derechos ARCO-POL",
    body: "Puede ejercer Acceso, Rectificación, Cancelación, Oposición, Portabilidad, Olvido y Limitación escribiendo a info@agdysa.com.",
  },
  {
    id: "trafico",
    title: "Estadísticas de visita",
    body: "Con consentimiento de analítica: visitas totales y por IP. Sin ese consentimiento: solo totales agregados y rutas, sin IP ni datos sensibles. Detalle en la Política de cookies.",
  },
];

export const DEFAULT_COOKIES_SECTIONS = [
  {
    id: "que-es",
    title: "¿Qué es una cookie?",
    body: "Información que un sitio almacena en su navegador para recordar accesos o hábitos de navegación. También usamos almacenamiento local (localStorage) con fines equivalentes.",
  },
  {
    id: "gestion",
    title: "Cómo gestionar el consentimiento",
    body: "Use el aviso emergente, el botón Configurar cookies del pie de página o esta política. Puede aceptar, rechazar o elegir categoría por categoría.",
  },
];

export function defaultLegalDoc() {
  return {
    privacyTitle: "Aviso de privacidad",
    privacySubtitle: "Tratamiento de datos personales",
    privacyUpdated: "10 de septiembre de 2026",
    privacyContact: "info@agdysa.com",
    privacySections: DEFAULT_PRIVACY_SECTIONS,
    cookiesTitle: "Política de cookies",
    cookiesSubtitle: "Cookies y tecnologías similares",
    cookiesUpdated: "10 de septiembre de 2026",
    cookiesIntro:
      "Esta política describe las cookies y el almacenamiento local en agdysa.com. Los formularios recolectan datos personales distintos; ese tratamiento está en el aviso de privacidad. Abajo se indica, por cada ítem, qué ocurre con consentimiento y sin consentimiento.",
    cookiesSections: DEFAULT_COOKIES_SECTIONS,
    consentMatrix: DEFAULT_CONSENT_MATRIX,
    legalDisclaimer:
      "Texto editable desde el CMS. Validar con asesoría legal en El Salvador antes de versión definitiva.",
  };
}
